import { Uuid } from "@/domains/global/identifiers";
import { api } from "@/modules/api";
import { useQuery } from "@tanstack/react-query";

import { FC } from "react";
import { useParams } from "react-router";

export const SyncModelCvrSnapshotsViewPage: FC = () => {
  const { syncModelCvrSnapshotId } = useParams<{ syncModelCvrSnapshotId: Uuid }>();

  if (!syncModelCvrSnapshotId) {
    return <div>Invalid ID</div>;
  }

  const result = useQuery({
    queryKey: ["sync-model-cvr-snapshot-by-id", syncModelCvrSnapshotId],
    queryFn: () =>
      api.get("/internal/v1/sync-model-cvr-snapshots/{sync_model_cvr_snapshot_id}", {
        params: {
          path: {
            sync_model_cvr_snapshot_id: syncModelCvrSnapshotId,
          },
        },
      }),
  });

  return (
    <div>
      <h1>View SyncModelCvrSnapshot</h1>
      <pre>{JSON.stringify(result.data, null, 2)}</pre>
    </div>
  );
};
